export enum TICKET_FILTER  {
  ALL = 0,
  ALL_HAVE_DEADLINE =189,
  NEAR_DEADLINE = 190,
  OVER_DEADLINE = 191,

  DEFAULT_NEAR_DEADLINE_MINS = 10,

}
